
import React, { useState, useEffect } from 'react';
import './Newprofile.css';
import defaultImage from "../modules/Component/Profile/profile.png";
import { FaUser, FaEnvelope, FaPhone, FaCamera, FaEdit, FaSave, FaTrash, FaTimes, FaUserCircle } from 'react-icons/fa';
import Adressnew from '../../pages/sidebarcall/Adressnew.jsx';
import Acountseeting from '../../pages/sidebarcall/Acountseeting.jsx';
import axios from "axios";
const ProfilePremium = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedImageBase64, setSelectedImageBase64] = useState(null);
  const [profile, setProfile] = useState(null);

  // User details state
  const [userDetails, setUserDetails] = useState({
    userName: "",
    emailId: "",
    mobileNumber: "",
    image: localStorage.getItem("profileImagePremium") || "",
  });

  // Detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId || !token) {
          console.error("User not logged in");
          return;
        }

        const res = await axios.get(
          `https://backend.maamaas.com/subscription/api/user/account/get/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setProfile(res.data);
      } catch (error) {
        console.error(
          "Error fetching profile:",
          error.response?.data || error.message
        );
      }
    };

    fetchProfile();
  }, []);

  // Fetch profile from API
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      setError("User not logged in.");
      setLoading(false);
      return;
    }

    const apiUrl = `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`;

    const fetchProfile = async () => {
      try {
        const response = await fetch(apiUrl, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!response.ok) throw new Error("Failed to fetch profile");
        const data = await response.json();

        if (data.image) {
          localStorage.setItem("profileImagePremium", data.image);
        }

        setUserDetails({
          userName: data.userName || "",
          emailId: data.emailId || "",
          mobileNumber: data.mobileNumber || "",
          image: data.image || localStorage.getItem("profileImagePremium") || "",
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({ ...prev, [name]: value }));
  };

  // Handle image upload and update (instantly UI + localStorage + server)
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      setSelectedImageBase64(base64);
      setUserDetails((prev) => ({ ...prev, image: base64 }));
      localStorage.setItem("profileImagePremium", base64);
      updateProfile(base64); // auto-save on image change
    };
    reader.readAsDataURL(file);
  };

  // Update profile API call
  const updateProfile = async (imageFile) => {
  try {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    const formData = new FormData();

    formData.append("userName", userDetails.userName || "");
    formData.append("emailId", userDetails.emailId || "");
    formData.append("mobileNumber", userDetails.mobileNumber || "");

    // imageFile must be actual File object
    if (imageFile instanceof File) {
      formData.append("image", imageFile);
    }

    // Debug
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await fetch(
      `https://backend.maamaas.com/subscription/api/user/editprofile/${userId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    const data = await response.json();

    console.log("response", data);

    if (!response.ok) {
      throw new Error(data.message || "Profile update failed");
    }

    return data;
  } catch (err) {
    console.log(err);
  }
};

  // Save button handler (edit mode)
  const handleSaveClick = async () => {
    setIsSaving(true);
    setError("");
    try {
      await updateProfile(selectedImageBase64 || userDetails.image);
      setIsEditing(false);
      setSelectedImageBase64(null);
    } catch (err) {
      setError("Failed to save profile");
    } finally {
      setIsSaving(false);
    }
  };

  // Delete account
  const handleDeleteAccount = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    if (!userId) {
      setError("No userId found");
      return;
    }
    try {
      const response = await fetch(
        `https://backend.maamaas.com/subscription/api/user/delete/account/${userId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
      if (response.ok) {
        alert("Account deleted successfully");
        localStorage.clear();
        window.location.href = "/";
      } else {
        const errMsg = await response.text();
        throw new Error(errMsg || "Failed to delete account");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  // Get final image source
  const getImageSource = () => {
    const img = userDetails.image || localStorage.getItem("profileImagePremium");
    if (!img || img === "") return defaultImage;
    return img;
  };

  if (loading) {
    return (
      <div className="premiumProfile-loaderContainer">
        <div className="premiumProfile-spinner"></div>
        <p>Loading premium profile...</p>
      </div>
    );
  }

  return (
    <div className="premiumProfile-root">
      <div className="premiumProfile-container">

        {/* Main Card */}
        <div className="premiumProfile-mainCard">
          <div className="premiumProfile-grid">
            {/* Left Column - Avatar Section */}
          <div className="premiumProfile-avatarColumn">
  <div className="premiumProfile-avatarWrapper">

    {/* Progress Circle */}
    <div
      className="premiumProfile-progressRing"
      style={{
        "--progress": `${profile?.completionPercentage || 0}`,
      }}
    >
      {/* Inner Circle */}
      <div className="premiumProfile-progressInner">

        {/* Avatar */}
        <div className="premiumProfile-avatarContainer">
          <img
            src={getImageSource()}
            alt="Profile"
            className="premiumProfile-avatarImg"
          />

          {/* Upload Icon */}
          <label
            htmlFor="premiumImageUpload"
            className="premiumProfile-uploadBtn"
          >
            <FaCamera />
          </label>
        </div>
      </div>

      {/* Moving Number */}
      <div
        className="premiumProfile-progressCount"
        style={{
          transform: `rotate(${(profile?.completionPercentage || 0) * 3.6}deg)
          translateY(-108px)
          rotate(-${(profile?.completionPercentage || 0) * 3.6}deg)`,
        }}
      >
        {profile?.completionPercentage || 0}%
      </div>
    </div>

    <input
      type="file"
      id="premiumImageUpload"
      accept="image/*"
      style={{ display: "none" }}
      onChange={handleImageChange}
    />

    {/* TEXT BELOW IMAGE */}
    <div className="premiumProfile-infoBox">
     
      <p>
        Profile Completion :
        <span>
          {profile?.completionPercentage || 0}%
        </span>
      </p>

      <small>
        {100 - (profile?.completionPercentage || 0)}% Remaining
      </small>
    </div>
  </div>
</div>


            {/* Right Column - Details Form */}
            <div className="premiumProfile-detailsColumn">
              <div className="premiumProfile-cardHeader">
                <h3 className="premiumProfile-sectionTitle">Personal Information</h3>
                <div className="premiumProfile-actionGroup">
                  {!isEditing ? (
                    <button
                      className="premiumProfile-btn premiumProfile-btnEdit"
                      onClick={() => setIsEditing(true)}
                    >
                      <FaEdit /> <span>Edit Profile</span>
                    </button>
                  ) : (
                    <button
                      className="premiumProfile-btn premiumProfile-btnSave"
                      onClick={handleSaveClick}
                      disabled={isSaving}
                    >
                      <FaSave /> <span>{isSaving ? "Saving..." : "Save Changes"}</span>
                    </button>
                  )}
                  <button
                    className="premiumProfile-btn premiumProfile-btnDelete"
                    onClick={() => setShowDeleteConfirm(true)}
                  >
                    <FaTrash /> <span>Delete</span>
                  </button>
                </div>
              </div>

              {error && <div className="premiumProfile-errorMsg">{error}</div>}

              <div className="premiumProfile-formGroup">
                <div className="premiumProfile-inputIcon">
                  <FaUser />
                </div>
                <input
                  type="text"
                  name="userName"
                  className="premiumProfile-input"
                  value={userDetails.userName}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  placeholder="Full Name"
                />
              </div>

              <div className="premiumProfile-formGroup">
                <div className="premiumProfile-inputIcon">
                  <FaEnvelope />
                </div>
                <input
                  type="email"
                  name="emailId"
                  className="premiumProfile-input"
                  value={userDetails.emailId}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  placeholder="Email Address"
                />
              </div>

              <div className="premiumProfile-formGroup">
                <div className="premiumProfile-inputIcon">
                  <FaPhone />
                </div>
                <input
                  type="tel"
                  name="mobileNumber"
                  className="premiumProfile-input"
                  value={userDetails.mobileNumber}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  placeholder="Mobile Number"
                />
              </div>

              {/* <div className="premiumProfile-metaInfo">
  {profile ? (
    <>
      <p>
        📊 Profile Completion:{" "}
        <strong>{profile.completionPercentage}%</strong>
      </p>

     
      <div
        style={{
          background: "#eee",
          height: "4px",   // 👈 yaha slim kiya
          borderRadius: "10px",
          overflow: "hidden",
          margin: "6px 0",
        }}
      >
        <div
          style={{
            width: `${profile.completionPercentage}%`,
            background: "linear-gradient(90deg, #FFD700, #FFA500)",
            height: "100%",
            transition: "width 0.4s ease",
          }}
        ></div>
      </div>

      <p style={{ fontSize: "12px", color: "#777" }}>
        🧩 {100 - profile.completionPercentage}% profile remaining
      </p>
    </>
  ) : (
    <p>Loading...</p>
  )}
</div> */}
            </div>
          </div>
        </div>
        {/* <Adressnew /> */}
        <Acountseeting />

      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="premiumProfile-modalOverlay">
          <div className="premiumProfile-modal">
            <div className="premiumProfile-modalHeader">
              <h3>Delete Account</h3>
              <button
                className="premiumProfile-modalClose"
                onClick={() => setShowDeleteConfirm(false)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="premiumProfile-modalBody">
              <div className="premiumProfile-warningIcon">
                <FaTrash />
              </div>
              <p>Are you absolutely sure? This action is irreversible and all your data will be permanently removed.</p>
            </div>
            <div className="premiumProfile-modalFooter">
              <button
                className="premiumProfile-modalCancel"
                onClick={() => setShowDeleteConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="premiumProfile-modalConfirm"
                onClick={handleDeleteAccount}
              >
                Yes, Delete Account
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePremium;